// const textInput = props => `
//   color: ${props.error ? color.white : color.base};
//   background-color: ${props.error ? color.alert : color.white};
// `;

// export const Input = styled.input`
//   ${textInput}
// `;

// export const Textarea = styled.textarea`
//   ${textInput};
//   height: ${props => props.height ? props.height : '130px'}
//   resize: none;
//   overflow: auto;
// `;

export const modifySize = (fontString, modifyFrac) => {
  const fontNumber = parseFloat(fontString)
  const fontUnit = fontString.replace(/[0-9]/g, '')
  return `${fontNumber * modifyFrac}${fontUnit}`
}

export const flexCenter = () => `
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
`

export const frameSmall = ({ theme }) => {
  return `
    padding: ${theme['padding-small']};
    margin: ${theme['margin-small']};
`
}

export const frameMedium = ({ theme }) => `
    padding: ${theme['padding-medium']};
    margin: ${theme['margin-medium']};
`

export const heading = ({ theme }, size, color) => {
  const setColor = color ? color : theme['main-color']

  return `
    text-align: center;
    font-size: ${size};
    font-weight: bold;
    color: ${setColor};
    @media ${theme['mobile']} {
        font-size: ${modifySize(size, 1 / 1.5)};
    }
    @media ${theme['tablet']} {
        font-size: ${modifySize(size, 1 / 1.5)};
    }
`
}

export const label = ({ theme }, background, text, border) => {
  const setBackground = background ? background : theme['label-theme']
  const setText = text ? text : theme['main-color']
  const setBorder = border ? background : theme['label-border']
  return `
    background-color: ${setBackground};
    color: ${setText};
    border: ${setBorder};
    margin: ${theme['margin-small']};
    padding: ${modifySize(theme['padding-small'], 1 / 2)} ${
    theme['padding-medium']
  };
    box-shadow: ${theme['label-box-shadow']};
    `
}

export const labelHover = ({ theme }, background, text, border) => {
  const setBackground = background ? background : theme['label-theme']
  const setText = text ? text : theme['main-color']
  const setBorder = border ? background : theme['label-border']
  return `
        transition: ${theme['transition-time']} background-color;
        &:hover {
            .label(${setBackground}, ${setText}, ${setBorder});
        }
      `
}
